import { useLayoutEffect, useRef, useState } from 'react';
import { createOwnerCameraArchiveApi } from '../../services/ownerCameraArchiveApi';
import { createOwnerCameraArchive } from '../../services/OwnerCameraArchive';

const closed = { open: false };
export function useOwnerCameraArchive(scope) {
  const scopeRef = useRef(scope); scopeRef.current = scope;
  const [snapshot, setSnapshot] = useState(null);
  useLayoutEffect(() => {
    if (!scope?.identity || !scope?.ownerId || !scope?.backendService) return undefined;
    let active = true, manager;
    const isCurrent = () => active && scopeRef.current === scope;
    try {
      const api = createOwnerCameraArchiveApi({ ...scope, isCurrent });
      manager = createOwnerCameraArchive({ api, isCurrent });
    } catch { return undefined; }
    setSnapshot({ scope, manager, state: manager.getState() });
    const unsubscribe = manager.subscribe(state => setSnapshot({ scope, manager, state }));
    const background = () => manager.close();
    const visibility = () => { if (document.visibilityState === 'hidden') background(); };
    document.addEventListener('visibilitychange', visibility);
    window.addEventListener('pagehide', background);
    return () => {
      active = false; unsubscribe(); manager.dispose();
      document.removeEventListener('visibilitychange', visibility);
      window.removeEventListener('pagehide', background);
    };
  }, [scope]);
  const current = snapshot?.scope === scope ? snapshot : null;
  const manager = current?.manager;
  return { available: Boolean(manager), state: current?.state || closed,
    open: () => { if (document.visibilityState !== 'hidden') manager?.open(); },
    close: () => manager?.close(), load: more => manager?.load(more), select: id => manager?.select(id),
    play: name => manager?.play(name), remove: id => manager?.remove(id), playbackError: () => manager?.playbackError() };
}
